export default "__VITE_ASSET__k8FX1b8M__"